export default __webpack_public_path__ + "static/media/craftyCell.3810e59c.png";